import * as storage from './storage'

const utils = {
    storage
}

export default utils
